import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";

export default function CreatorDetail() {
  const { id } = useParams();
  const [d, setD] = useState(null);
  useEffect(() => { window.scrollTo(0, 0); api.get(`/creators/${id}`).then(({ data }) => setD(data)); }, [id]);
  if (!d) return <div className="h-[50vh]" />;
  const c = d.creator;

  return (
    <div>
      <section className="bg-[#0A0A0A] text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 grid lg:grid-cols-[320px_1fr] gap-12 items-center">
          <div className="aspect-square bg-[#161616] overflow-hidden">
            {c.portrait_url ? <img src={c.portrait_url} alt={c.brand_name} className="w-full h-full object-cover opacity-90" />
              : <div className="w-full h-full flex items-center justify-center"><span className="font-display text-3xl text-white">{c.brand_name}</span></div>}
          </div>
          <div>
            <span className="over text-[0.62rem] text-[#D4AF37]">{c.main_category} · {c.city}, {c.country}</span>
            <h1 className="font-display text-5xl lg:text-6xl font-light mt-3">{c.brand_name}</h1>
            <p className="text-neutral-300 mt-5 leading-relaxed max-w-2xl">{c.universe}</p>
          </div>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-16">
        <div className="flex items-center justify-between mb-10">
          <h2 className="font-display text-3xl">Ses créations</h2>
          <Link to="/createurs" className="over text-[0.62rem] link-underline">Tous les créateurs</Link>
        </div>
        {d.products.length === 0 ? <p className="text-neutral-500">Aucune création disponible pour le moment.</p> : (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-8 lg:gap-x-8">
            {d.products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
          </div>
        )}
      </div>
    </div>
  );
}
